export const redirectToCheckoutConfirmation = (
  checkoutResponse: any,
  checkoutConfirmationUrl: string,
) => {
  const processorId =
    checkoutResponse?.subscription_processor_id ||
    checkoutResponse?.payment_intent_processor_id ||
    checkoutResponse?.invoice_processor_id;
  const url = `${checkoutConfirmationUrl}${processorId}`;

  window.webview?.paymentSuccessful?.({ redirect_url: url });
  return window.open(url, "_self");
};

const PAYMENT_POLLING_TIMEOUT_MILLISECONDS = 2000;
const PAYMENT_POLLING_MAX_TRIES = 30;

const resolveSleep = async (
  sleepTimeInMilliseconds = PAYMENT_POLLING_TIMEOUT_MILLISECONDS,
) => new Promise(resolve => setTimeout(resolve, sleepTimeInMilliseconds));

interface ProcessWithRetriesProp<T extends object> {
  executor: () => Promise<T | null>;
  retriesThreshold?: number;
  sleepTimeInMilliseconds?: number;
}

export const processWithRetries = async <T extends object>({
  retriesThreshold = PAYMENT_POLLING_MAX_TRIES,
  sleepTimeInMilliseconds = PAYMENT_POLLING_TIMEOUT_MILLISECONDS,
  executor,
}: ProcessWithRetriesProp<T>): Promise<T | null> => {
  let output = null;
  for (let retryIndex = 0; retryIndex < retriesThreshold; retryIndex++) {
    output = await executor();

    if (output) {
      break;
    }

    await resolveSleep(sleepTimeInMilliseconds);
  }

  return output;
};
